import { Injectable } from '@angular/core';
import jwt_decode from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class JwtUtils {

  getTokenExpirationDate(token: string): Date {
    const decoded: any = jwt_decode(token);

    console.log("Decoded Token: ", decoded);
    if (decoded.exp === undefined) {
      return null as any;
    }

    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);

    return date;
  }

  isTokenExpired(token: string): boolean {
    const date = this.getTokenExpirationDate(token);
    if (date === null) {
      return false;
    }

    return !(date.valueOf() > new Date().valueOf());
  }
}
